define("StockItemActions.View", [
  "Backbone",
  "ProductDetails.Full.View",
  "ExternalVendor.Inventory.SS2Model",
  "ProductStructuredData.Helper",
  "Configuration",
  "Profile.Model",
  "jQuery",
], function (
  Backbone,
  ProductDetailsFull,
  ExternalVendorInventoryModel,
  ProductStructuredDataHelper,
  Configuration,
  ProfileModel,
  jQuery
) {
  "use strict";

  function getCurrencyCode() {
    return SC.getSessionInfo("currency") &&
      SC.getSessionInfo("currency").code
      ? SC.getSessionInfo("currency").code
      : Configuration.get("siteSettings.shopperCurrency.code") || "CAD";
  }

  function getStructuredValue(layout, property) {
    var element = layout
      .$('[data-product-structured="' + property + '"]')
      .first();

    return element.attr("content") || element.attr("href") || element.text() || "";
  }

  function getStructuredDescription(layout) {
    return (
      getStructuredValue(layout, "description") ||
      getStructuredValue(layout, "name")
    );
  }

  function getStructuredImage(layout) {
    return getStructuredValue(layout, "image");
  }

  function getStructuredPrice(layout) {
    return (
      getStructuredValue(layout, "price") ||
      getStructuredValue(layout, "lowPrice")
    );
  }

  function getStructuredAvailability(layout) {
    var availability = getStructuredValue(layout, "availability");
    var parts = availability.split("/");
    return parts[parts.length - 1] || "";
  }

  function getStructuredOrigin(layout) {
    var url = getStructuredValue(layout, "url");
    var match = url.match(/^https?:\/\/[^/]+/i);
    return match ? match[0] : "";
  }

  function getTwitterPrice(layout) {
    var amount = getStructuredPrice(layout);
    var currency = getStructuredValue(layout, "priceCurrency");
    var numericAmount = Number(amount);
    var formattedAmount;
    var symbol = currency === "CAD" || currency === "USD" ? "$" : "";

    if (!amount) return currency;

    formattedAmount = isFinite(numericAmount)
      ? numericAmount.toFixed(2)
      : amount;

    return symbol + formattedAmount + (currency ? " " + currency : "");
  }

  function installOpenGraphMappings() {
    var mapping = Configuration.metaTagMappingOg;

    if (!mapping) return;

    mapping["og:title"] = function (layout) {
      return getStructuredValue(layout, "name");
    };
    mapping["og:url"] = function (layout) {
      return getStructuredValue(layout, "url");
    };
    mapping["og:image"] = function (layout) {
      return getStructuredImage(layout);
    };
    mapping["og:image:url"] = function (layout) {
      return getStructuredImage(layout);
    };
    mapping["og:image:secure_url"] = function (layout) {
      return getStructuredImage(layout);
    };
    mapping["og:image:alt"] = function (layout) {
      return getStructuredValue(layout, "name");
    };
    mapping["og:description"] = function (layout) {
      return getStructuredDescription(layout);
    };
    mapping["og:price:standard_amount"] = function (layout) {
      return getStructuredPrice(layout);
    };
    mapping["og:price:currency"] = function (layout) {
      return getStructuredValue(layout, "priceCurrency");
    };
    mapping["og:availability"] = function (layout) {
      return getStructuredAvailability(layout);
    };
    mapping["og:rating"] = function (layout) {
      return getStructuredValue(layout, "ratingValue");
    };
    mapping["og:rating_scale"] = function (layout) {
      return getStructuredValue(layout, "bestRating");
    };
    mapping["og:rating_count"] = function (layout) {
      return getStructuredValue(layout, "reviewCount");
    };
  }

  function installTwitterProductMappings() {
    var mapping = Configuration.metaTagMappingTwitterProductCard;

    if (!mapping) return;

    mapping["twitter:title"] = function (layout) {
      return getStructuredValue(layout, "name");
    };
    mapping["twitter:description"] = function (layout) {
      return getStructuredDescription(layout).substring(0, 200);
    };
    mapping["twitter:image:src"] = function (layout) {
      return getStructuredImage(layout);
    };
    mapping["twitter:image"] = function (layout) {
      return getStructuredImage(layout);
    };
    mapping["twitter:image:alt"] = function (layout) {
      return getStructuredValue(layout, "name");
    };
    mapping["twitter:domain"] = function (layout) {
      return getStructuredOrigin(layout);
    };
    mapping["twitter:data1"] = function (layout) {
      return getTwitterPrice(layout);
    };
    mapping["twitter:label1"] = function () {
      return "PRICE";
    };
    mapping["twitter:data2"] = function (layout) {
      return getStructuredAvailability(layout);
    };
    mapping["twitter:label2"] = function () {
      return "AVAILABILITY";
    };
  }

  installOpenGraphMappings();
  installTwitterProductMappings();

  return _.extend(ProductDetailsFull.prototype, {
    initialize: _.wrap(ProductDetailsFull.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      var self = this;
      self.initialiazing = true;
      var externalVendorInventory = ExternalVendorInventoryModel.getInstance();
      externalVendorInventory.set("addToCartEnabled", undefined);
      this.listenTo(
        externalVendorInventory,
        "change:addToCartEnabled",
        function () {
          self.addToCartEnabled =
            externalVendorInventory.get("addToCartEnabled");
          if (self.initialiazing) {
            self.initialiazing = false;
            self.render();
          } else {
            if (!self.addToCartEnabled) {
              $('[id="MainAction"]').addClass("hide");
              $('[id="addToCartAndShop"]').addClass("hide");
              $('[id="AddToQuote"].main').removeClass("hide");
              $('[id="AddToQuote"].secondary').addClass("hide");
            } else {
              $('[id="MainAction"]').removeClass("hide");
              $('[id="addToCartAndShop"]').removeClass("hide");
              $('[id="AddToQuote"].main').addClass("hide");
              $('[id="AddToQuote"].secondary').removeClass("hide");
            }
          }
        }
      );
    }),
    buildProductStructuredData: function (context) {
      var item = this.model.get("item");
      var itemUrl =
        (context && context.itemUrl) ||
        item.get("_url") + this.model.getQuery();
      var profile = ProfileModel.getInstance();

      return ProductStructuredDataHelper.build({
        item: item,
        itemUrl: itemUrl,
        canonicalUrl: this.getCanonical(),
        origin: window.location.origin,
        name: this.page_header,
        description: this.getMetaDescription(),
        sku: this.model.getSku(),
        images: this.model.getImages(),
        price: this.model.getPrice(),
        currency: getCurrencyCode(),
        structuredDataType: Configuration.get("structureddatamarkup.type"),
        includeOffer:
          !profile.hidePrices() && item.get("ispricevisible") !== false,
      });
    },
    getJsonLd: function (childJsonLd) {
      var childReviews;

      if (Configuration.get("structureddatamarkup.type") !== "JSON-LD") {
        return jQuery.Deferred().resolve(null);
      }

      childJsonLd = childJsonLd || {};
      childReviews = childJsonLd.review;

      // Backbone.CompositeView merges the child result after this result. Remove
      // the ProductReviews Offer type and aggregate so they cannot overwrite the
      // canonical Product and AggregateRating assembled here.
      delete childJsonLd["@type"];
      delete childJsonLd.aggregateRating;

      return jQuery
        .Deferred()
        .resolve(
          ProductStructuredDataHelper.toJsonLd(
            this.buildProductStructuredData(),
            { review: childReviews }
          )
        );
    },
    getContext: _.wrap(ProductDetailsFull.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      context.addToCartEnabled =
        this.addToCartEnabled !== undefined ? this.addToCartEnabled : true;
      context.productStructuredData = this.buildProductStructuredData(context);
      //set the initial actions to be able to purchase, however it should be depending on the stock levels
      return context;
    }),
  });
});
